import React, { useEffect } from "react";

function NotFound() {
  useEffect(() => {
    document.location.href = "/";
  }, []);

  return <div></div>;
}

export default NotFound;
